import { Providers } from './providers';
import { AppRoutes } from './router';

export default function App() {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
